import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiUsers, FiAward, FiTrendingUp } from "react-icons/fi";

export default function Careers() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      {/* HERO SECTION */}
      <section className="relative w-full h-[60vh] min-h-[400px] flex items-center justify-center bg-green-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/40 z-10" />
        <img 
          src="/images/careers2.jpg" 
          alt="Team collaboration" 
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
        <div className="relative z-20 text-center px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight text-yellow-400">Join Our Team</h1>
          <p className="text-xl md:text-2xl font-light mb-8 opacity-90">
            Empower the future. Build a career that makes a difference.
          </p>
          <Link to="/search-jobs" className="inline-flex items-center gap-2 bg-yellow-500 text-gray-900 font-semibold px-8 py-4 rounded-full hover:bg-yellow-400 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1">
            View Job Openings <FiArrowRight />
          </Link>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="py-20 px-4 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-sm font-bold tracking-widest text-green-700 uppercase mb-2">Who We Are</h2>
            <h3 className="text-4xl font-bold mb-6 text-gray-900">Dedicated to Excellence and Innovation</h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We are a dynamic and forward-thinking company, deeply committed to providing sustainable and innovative solutions. Our team thrives on collaboration, creativity, and a shared vision of making a meaningful impact in our industry and the communities we serve.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              When you join us, you become part of a diverse group of professionals who are passionate about delivering top-tier results and pushing the boundaries of what is possible.
            </p>
          </div>
          <div className="relative overflow-hidden shadow-2xl h-80 bg-gray-200">
              <img 
              src="/images/careers1.png" 
              alt="Team collaboration" 
              className="absolute inset-0 w-full h-full object-cover z-0"
            />
            
          </div>
        </div>
      </section>

      {/* OUR CULTURE */}
      <section className="py-20 bg-green-800 text-white px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-sm font-bold tracking-widest text-yellow-400 uppercase mb-2">Our Culture</h2>
          <h3 className="text-4xl font-bold mb-8">Grounded in Commitment</h3>
          <p className="text-xl md:text-2xl font-light leading-relaxed mb-10">
            "We are grounded in our commitment to our principles, our people, and our clients."
          </p>
          <div className="w-24 h-1 bg-yellow-500 mx-auto rounded-full"></div>
        </div>
      </section>

      {/* BENEFITS & CAREER DEVELOPMENT */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16">
          
          <div className="bg-gray-50 p-10 rounded-3xl border border-gray-100 hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-green-100 text-green-700 rounded-2xl flex items-center justify-center text-2xl mb-6">
              <FiAward />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Benefits</h3>
            <p className="text-lg text-gray-600 mb-6">
              We strive to provide best-in-class benefits for our employees in and out of work.
            </p>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-yellow-500 rounded-full" /> Comprehensive Health Insurance</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-yellow-500 rounded-full" /> Flexible Work Arrangements</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-yellow-500 rounded-full" /> Retirement Savings Plans</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-yellow-500 rounded-full" /> Paid Time Off & Wellness Days</li>
            </ul>
          </div>

          <div className="bg-gray-50 p-10 rounded-3xl border border-gray-100 hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-yellow-100 text-yellow-600 rounded-2xl flex items-center justify-center text-2xl mb-6">
              <FiTrendingUp />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Career Development</h3>
            <p className="text-lg text-gray-600 mb-6">
              Your growth is our growth. We invest heavily in the professional development of our team members.
            </p>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-green-600 rounded-full" /> Continuous Learning Programs</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-green-600 rounded-full" /> Leadership Training</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-green-600 rounded-full" /> Mentorship Opportunities</li>
              <li className="flex items-center gap-3"><div className="w-2 h-2 bg-green-600 rounded-full" /> Clear Promotion Pathways</li>
            </ul>
          </div>

        </div>
      </section>

      {/* GET TO KNOW OUR PEOPLE */}
      {/* <section className="py-20 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold tracking-widest text-green-700 uppercase mb-2">Get to know our people</h2>
          <h3 className="text-4xl font-bold text-gray-900">Meet The Team</h3>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { name: "Sarah Johnson", role: "Head of Engineering", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800" },
            { name: "David Okon", role: "Customer Success Lead", img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=800" },
            { name: "Aisha Bello", role: "Operations Manager", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=800" }
          ].map((person, idx) => (
            <div key={idx} className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer">
              <div className="aspect-w-3 aspect-h-4 bg-gray-200 h-96">
                <img src={person.img} alt={person.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-6">
                <h4 className="text-white font-bold text-xl">{person.name}</h4>
                <p className="text-yellow-400">{person.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* JOBS FOR YOU */}
      <section className="py-24 bg-green-50 text-center px-4">
        <div className="max-w-3xl mx-auto">
          <div className="w-16 h-16 bg-green-900 text-yellow-400 rounded-full flex items-center justify-center text-2xl mx-auto mb-6">
            <FiUsers />
          </div>
          <h3 className="text-4xl font-bold mb-6 text-gray-900">Jobs For You</h3>
          <p className="text-lg text-gray-600 mb-8">
            Ready to take the next step in your career? Explore our open positions and find the perfect role for your skills and ambitions.
          </p>
          <Link to="/search-jobs" className="inline-flex items-center gap-2 bg-green-700 text-white font-semibold px-8 py-4 rounded-full hover:bg-green-800 transition-colors shadow-lg">
            Explore Open Vacancies <FiArrowRight />
          </Link>
        </div>
      </section>

    </div>
  );
}